module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/100mil-fundo-ouro-964f8797742924c7d6576a47ea453a95.png";